"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNewCoupon = void 0;
// 入驻
var base_1 = __importDefault(require("../../base"));
var page_config_1 = __importDefault(require("./page_config"));
// config
var BASE_URL = '/transaction';
var betaHost = 'http://20201103-lyn-code.ks-fe-ll-transaction.jinx.corp.kuaishou.com/transaction/coupon/index.html';
var COUPON_HOSTS = {
    production: 'https://lbs.kuaishou.com/transaction/coupon/index.html',
    beta: betaHost,
};
var coupon = new base_1.default({
    host: COUPON_HOSTS,
    bridgeQuery: {},
    history: false,
    pages: page_config_1.default,
    baseUrl: BASE_URL,
    stagingBaseUrl: '/transaction/coupon/index.html',
});
var createNewCoupon = function (jumpOptions) {
    jumpOptions.betaHost && (COUPON_HOSTS.beta = jumpOptions.betaHost);
    return new base_1.default({
        host: COUPON_HOSTS,
        bridgeQuery: jumpOptions.bridgeQuery || {},
        history: jumpOptions.history || false,
        pages: __assign(__assign({}, page_config_1.default), (jumpOptions.pages || {})),
        baseUrl: jumpOptions.baseUrl || BASE_URL,
        stagingBaseUrl: jumpOptions.stringBaseUrl || '/transaction/coupon/index.html',
    });
};
exports.createNewCoupon = createNewCoupon;
exports.default = coupon;
